// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/top-bar/module';
import './modules/theme/hero-slider/module';
import './modules/theme/category-section/module';
import './modules/theme/video-widget/module';
import './modules/theme/brands/module';
import './modules/theme/item-merch/module';
import './modules/theme/info-cards/module';
import './modules/theme/testimonials/module';
import './modules/theme/blogs/module';
import './modules/theme/contact-form/module';
import './modules/theme/locations/module';

// layouts

// leave me last
import './js/base/base-end';
